// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps, react-hooks/rules-of-hooks */

import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Tooltip from "rc-tooltip";
import { Icon, Loader, Modal } from "semantic-ui-react";
import { useAuth0 } from "../../../auth/auth0";
import { useUserAuth } from "../../../hooks/useUserAuth";

import { toast } from "react-toastify";

import * as trialActions from "../../../redux/actions/trialActions";

import PubUnpubTrialFlights from ".";
import "./loaderWorkaround.css";

const PubUnpubTrialFlightsFromSearch = ({ trialId, mode = "icon", modalOpen, setModalOpen }) => {
	const dispatch = useDispatch();
	const { getTokenSilently } = useAuth0();
	const userAuth = useUserAuth();

	//-- Trial data
	const [workingTrial, setWorkingTrial] = useState({});
	const [trialFlights, setTrialFlights] = useState([]);
	const [isTrialOwner, setIsTrialOwner] = useState(false);
	const [flightScheduleOptions, setFlightScheduleOptions] = useState([]);

	//-- UI Control
	const [loading, setLoading] = useState(true);
	const [refreshing, setRefreshing] = useState(false);

	const [localOpen, setLocalOpen] = setModalOpen !== null ? [modalOpen, setModalOpen] : useState(false);
	const [innerModalOpen, setInnerModalOpen] = useState(false);

	useEffect(() => {
		if (localOpen && trialId) {
			getTrialData(userAuth.currentClientId);
		}
	}, [localOpen, trialId]);

	async function getTrialData(clientId) {
		setLoading(true);

		const accessToken = await getTokenSilently();
		dispatch(trialActions.getTrialPublishingData(clientId, trialId, accessToken))
			.then((res) => {
				if (res) {
					setTrialData(res.trialData);
					setTrialFlights(res.trialFlights.concat(res.doNotPublishTrialFlights));
					setFlightScheduleOptions(res.flightScheduleOptions);
				}
			})
			.catch((err) => {
				console.error(`Error loading trial publishing data: ${err}`);
				setLocalOpen(false);
				setLoading(false);
				setRefreshing(false);
			});
	}

	const setTrialData = (trialData) => {
		const sponsors = (trialData.sponsors ?? []).map((s) => ({
			userId: s.sponsorUserId,
			personId: s.sponsorPersonId,
			name: s.sponsorUserId ? `${s.sponsorFirstName} ${s.sponsorLastName}` : "N/A",
			clientId: s.sponsorClientId,
			clientName: s.sponsorClientName,
			companyId: s.sponsorCompanyId,
			companyName: s.sponsorCompanyName,
			isPending: s.sponsorIsPending,
			emailAddress: s.sponsorEmailAddress,
		}));
		const td = {
			clientId: trialData.trialInfo.clientId,
			id: trialData.trialInfo.trialId,
			name: trialData.trialInfo.trialName,
			companyId: trialData.trialInfo.trialOwnerCompanyId,
			company: trialData.trialInfo.trialOwnerCompanyName,
			trialOwnerCompanyName: trialData.trialInfo.trialOwnerCompanyName,
			trialOwnerClientId: trialData.trialInfo.trialOwnerClientId,
			trialOwnerClientName: trialData.trialInfo.trialOwnerClientName,
			trialOwnerPersonId: trialData.trialInfo.trialOwnerPersonId,
			trialOwnerIsPending: trialData.trialInfo.trialOwnerIsPending,
			trialOwner: trialData.trialInfo.trialOwnerPersonId
				? `${trialData.trialInfo.trialOwnerFirstName} ${trialData.trialInfo.trialOwnerLastName}`
				: "N/A",
			trialOwnerEmail: trialData.trialInfo.trialOwnerEmailAddress,
			sponsors: sponsors,
			trialSponsorCompanyName: sponsors.length
				? sponsors
						.map((s) => s.companyName)
						.filter(Boolean)
						.join(", ")
				: "N/A",
			trialSponsorClientName: sponsors.length
				? sponsors
						.map((s) => s.clientName)
						.filter(Boolean)
						.join(", ")
				: null,
			trialSponsorIsPending: sponsors.some((s) => s.isPending),
			trialSponsor: sponsors.length ? sponsors.map((s) => s.name).join(", ") : "N/A",
			fieldResearcher: trialData.trialInfo.fieldResearcher,
			location: trialData.trialInfo.farmName,
			gpsCoordinates:
				trialData.trialInfo.plot101Lat && trialData.trialInfo.plot101Long
					? `${trialData.trialInfo.plot101Lat}, ${trialData.trialInfo.plot101Long}`
					: ``,
			plantDate: trialData.trialInfo.plantDate ? new Date(trialData.trialInfo.plantDate) : null,
			harvestDate: trialData.trialInfo.harvestDate ? new Date(trialData.trialInfo.harvestDate) : null,
			treatments: trialData.treatments,
			repCount: trialData.trialInfo.repCount,
			notes: trialData.trialInfo.notes ? trialData.trialInfo.notes : "",
			cooperatorName: trialData.trialInfo.cooperatorName,
			city: trialData.trialInfo.farmCity,
			region: trialData.trialInfo.farmRegion,
			countryCode: trialData.trialInfo.farmCountryCode,
			flightScheduleId: trialData.trialInfo.flightScheduleId,
		};

		setWorkingTrial(td);

		let trialOwnerCheck =
			trialData.trialInfo.trialOwnerClientId === userAuth.currentClientId ||
			trialData.trialInfo.trialOwnerUserId === userAuth.user.userInfo.basic.userId;
		setIsTrialOwner(trialOwnerCheck);

		let trialUserName = trialOwnerCheck ? td.trialSponsor : td.trialOwner;
		let isPending = trialOwnerCheck ? td.trialSponsorIsPending : td.trialOwnerIsPending;
		if (trialUserName === "N/A") {
			setLocalOpen(false);
			if (trialOwnerCheck) {
				toast.warn("Trial Sponsor must be set before trials can be published.");
			} else {
				toast.warn("Trial Owner must be set before trials can be published.");
			}
		} else if (isPending) {
			setLocalOpen(false);
			if (trialOwnerCheck) {
				toast.warn("Trial Sponsor does not have a valid license to publish this trial to.");
			} else {
				toast.warn("Trial Owner does not have a valid license to publish this trial to.");
			}
		} else {
			setInnerModalOpen(true);
		}

		setLoading(false);
		setRefreshing(false);
	};

	function handlePublishUnpublishSave() {
		setRefreshing(true);
		setLocalOpen(false);
	}

	return (
		<>
			<Modal
				trigger={
					mode === "icon" && (
						<Tooltip
							placement="bottom"
							mouseEnterDelay={0}
							mouseLeaveDelay={0}
							trigger="hover"
							overlay={<p>Publishing</p>}
							transitionName="rc-tooltip-zoom"
						>
							<a>
								<Icon
									style={{ cursor: "pointer" }}
									name="book"
									onClick={() => {
										setLocalOpen(true);
									}}
								/>
							</a>
						</Tooltip>
					)
				}
				open={localOpen}
			>
				{loading || refreshing ? (
					<>
						<Modal.Header>
							<Loader active className="workaround" />
							Getting Publishing/Unpublishing Data...
						</Modal.Header>
					</>
				) : (
					<PubUnpubTrialFlights
						trialFlights={trialFlights}
						isTrialOwner={isTrialOwner}
						handlePublishUnpublishSave={handlePublishUnpublishSave}
						trialUserName={isTrialOwner ? workingTrial.trialSponsor : workingTrial.trialOwner}
						isPending={isTrialOwner ? workingTrial.trialSponsorIsPending : workingTrial.trialOwnerIsPending}
						openModal={innerModalOpen}
						handleCancel={() => {
							setLocalOpen(false);
							setInnerModalOpen(false);
						}}
						flightScheduleId={workingTrial.flightScheduleId}
						flightScheduleOptions={flightScheduleOptions}
						cooperatorName={workingTrial.cooperatorName}
						city={workingTrial.city}
						region={workingTrial.region}
						countryCode={workingTrial.countryCode}
						trialName={workingTrial.name}
						trialSponsors={workingTrial.sponsors}
					/>
				)}
			</Modal>
		</>
	);
};

PubUnpubTrialFlightsFromSearch.propTypes = {
	trialId: PropTypes.string.isRequired,
	mode: PropTypes.string,
	modalOpen: PropTypes.bool,
	setModalOpen: PropTypes.func,
};

export default PubUnpubTrialFlightsFromSearch;
